import { API_BASE_URL } from "../api/http";
import { getAccessToken } from "./session";

const ABSOLUTE_URL_PATTERN = /^(?:[a-z]+:)?\/\//i;
const TRAILING_ENCODED_SPACE_PATTERN = /(?:%20)+$/gi;
const TRAILING_SPACE_PATTERN = /\s+$/g;
const DOC_EXTENSIONS = new Set([
  "pdf",
  "doc",
  "docx",
  "ppt",
  "pptx",
  "xls",
  "xlsx",
  "zip",
  "rar",
  "7z",
  "csv",
  "txt",
]);

function normalizeAbsoluteUrl(url) {
  const cleaned = `${url || ""}`
    .trim()
    .replace(TRAILING_ENCODED_SPACE_PATTERN, "")
    .replace(TRAILING_SPACE_PATTERN, "");
  if (!cleaned) return "";

  try {
    const parsed = new URL(cleaned);
    parsed.pathname = parsed.pathname
      .replace(TRAILING_ENCODED_SPACE_PATTERN, "")
      .replace(TRAILING_SPACE_PATTERN, "");
    return parsed.toString();
  } catch {
    return encodeURI(cleaned)
      .replace(TRAILING_ENCODED_SPACE_PATTERN, "")
      .replace(TRAILING_SPACE_PATTERN, "");
  }
}

function shouldUseSignedProxy(rawUrl) {
  try {
    const parsed = new URL(rawUrl);
    if (parsed.hostname !== "res.cloudinary.com") return false;
    const pathName = parsed.pathname.toLowerCase();
    const ext = pathName.includes(".")
      ? pathName.split(".").pop().split("/")[0].split("?")[0]
      : "";
    return pathName.includes("/raw/") || DOC_EXTENSIONS.has(ext);
  } catch {
    return false;
  }
}

function buildSignedProxyUrl(rawUrl) {
  const token = getAccessToken();
  const encodedUrl = encodeURIComponent(rawUrl);
  if (!token) return `${API_BASE_URL}/v1/files/open?url=${encodedUrl}`;
  return `${API_BASE_URL}/v1/files/open?url=${encodedUrl}&token=${encodeURIComponent(token)}`;
}

export function resolveMediaUrl(value) {
  const raw = `${value || ""}`
    .trim()
    .replace(TRAILING_ENCODED_SPACE_PATTERN, "")
    .replace(TRAILING_SPACE_PATTERN, "");
  if (!raw) return "";

  if (raw.startsWith("data:") || raw.startsWith("blob:")) {
    return raw;
  }

  if (ABSOLUTE_URL_PATTERN.test(raw)) {
    const normalized = normalizeAbsoluteUrl(raw);
    if (shouldUseSignedProxy(normalized)) {
      return buildSignedProxyUrl(normalized);
    }
    return normalized;
  }

  if (raw.startsWith("/")) {
    return `${API_BASE_URL}${raw}`;
  }

  return `${API_BASE_URL}/${raw}`;
}
